<div class="container">
  <h1 class="display-6 d-block">{{ 'Core.UserUsers' | translate:locale.language }}</h1>

  <dx-data-grid id="gridContainer" [dataSource]="dataSource" [remoteOperations]="true" [rowAlternationEnabled]="true"
    [showBorders]="true">
    <dxo-editing mode="row" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true" [useIcons]="true">
    </dxo-editing>
    <dxo-filter-row [visible]="true"> </dxo-filter-row>

    <dxi-column dataField="UserName" caption="{{ 'Core.Entity_UserUserName' | translate: locale.language }}"
      dataType="string">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="DisplayName" caption="{{ 'Core.Entity_UserName' | translate: locale.language }}"
      dataType="string">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="Email" caption="{{ 'Core.Account_Register_Email' | translate: locale.language }}"
      dataType="string">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule type="email"></dxi-validation-rule>
    </dxi-column>
    <dxi-column dataField="Role" caption="{{ 'Core.Role' | translate: locale.language }}" dataType="string">
      <dxo-lookup [dataSource]="rolesData" valueExpr="name" displayExpr="translation"></dxo-lookup>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
    <dxi-column *ngIf="sysAdmin" dataField="ProviderId" caption="{{ 'Project.Provider' | translate: locale.language }}"
      dataType="string">
      <dxo-lookup [dataSource]="providersData" valueExpr="id" displayExpr="name"></dxo-lookup>
    </dxi-column>
    <dxi-column dataField="Active" caption="{{ 'Core.EditActive' | translate: locale.language }}" dataType="boolean">
    </dxi-column>
    <dxi-column type="buttons">
      <dxi-button name="edit"></dxi-button>
      <dxi-button name="delete"></dxi-button>
      <dxi-button hint="Kupon generálás" icon="exportxlsx" [visible]="isGenerateCouponsIconVisible"
        [onClick]="onGenerateCouponsIconClick"></dxi-button>
      <dxi-button hint="Regisztrációs mail újraküldés" icon="email" [visible]="isSendingMailIconVisible"
        [onClick]="onSendingMailIconClick"></dxi-button>
    </dxi-column>

  </dx-data-grid>
</div>
<!-- Kupon generálás Modal -->
<ng-template #generateCoupons>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'Subscription.GenerateCoupons' | translate:locale.language }}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()" aria-label="Close">
    </button>
  </div>
  <div class="modal-body">

    <div class="col-md-3 mb-3 align-self-end">
      <div>
        <div class="form-label">Darabszám
        </div>
        <dx-number-box [stylingMode]="stylingMode" [(value)]="couponNumber">
        </dx-number-box>
      </div>
    </div>


    <div class="col-md-3 mb-3 align-self-end">
      <div>
        <div class="form-label">Prefix
        </div>
        <dx-text-box type="string" [stylingMode]="stylingMode" [(value)]="prefix">
        </dx-text-box>
      </div>
    </div>

    <div class="modal-footer px-0 d-flex align-items-center justify-content-between">
      <div>
        <dx-button stylingMode="contained" (onClick)="couponGeneration()"
          text="{{ 'Core.EditSave' | translate:locale.language }}" type="default" useSubmitBehavior=true>
        </dx-button>
        <button type="button" (click)="closeModal()" class="btn btn-neutral ms-2" data-bs-dismiss="modal">
          {{ 'Core.Close' | translate:locale.language }}
        </button>
      </div>
    </div>
    <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error | translate:locale.language}}</div>
  </div>
</ng-template>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#reg' }" [(visible)]="loading"
  [showIndicator]="true" [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>